import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTagModule } from 'shared/components/custom-tag/custom-tag.module';

import { AppointmentDetailsSessionDataComponent } from './appointment-details-session-data.component';

@NgModule({
	declarations: [AppointmentDetailsSessionDataComponent],
	exports: [AppointmentDetailsSessionDataComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudTypographyModule,
		CustomTagModule,
	],
})
export class AppointmentDetailsSessionDataModule {}
